const initial = {
  studentEnrollmentId: null,
  enrolmentNumber: "",
  studentBookingId: null,
  usiNumber: "",
  firstName: "",
  middleName: "",
  lastName: "",
  title: "",
  titleId: 0,
  dateOfBirth: "",
  gender: "",
  genderId: "",
  homePhone: "",
  workPhone: "",
  mobileNumber: "",
  email: "",
  preferredContactTypeId: "",
  buildingPropertyName: "",
  flatUnitDetails: "",
  streetNumber: "",
  streetName: "",
  suburb: "",
  postCode: "",
  state: "",
  stateId: 0,
  cityId: null,
  countryId: null,
  sameAsResidential: null,
  postalBuildingPropertyName: "",
  postalFlatUnitDetails: "",
  postalStreetNumber: "",
  postalStreetName: "",
  postalAddressLine1: "",
  postalSuburb: "",
  postalPostCode: "",
  postalState: "",
  postalStateId: 0,
  postalCityId: null,
  postalCountryId: null,
  emergencyContactName: "",
  emergencyRelationship: "",
  emergencyContactRelationshipId: null,
  emergencyPhone: "",
  countryOfBirth: "",
  countryOfBirthId: 0,
  townOfBirth: "",
  australianCitizen: "",
  indigenousStatus: "",
  indigenousStatusId: "",
  speakOtherLanguage: "",
  otherLanguage: "",
  englishProficiency: "",
  englishProficiencyId: 0,
  completedYear12: "",
  highestSchoolLevel: "",
  highestSchoolLevelId: 0,
  schoolCompletedYear: "",
  highestQualificationIds: [],
  priorEducationNote: "",
  ableToCompleteQualification: "",
  qualificationCompletedYear: "",
  hasConcessionCard: "",
  concessionCardNumber: "",
  employmentStatus: "",
  occupation: "",
  employmentStartDate: "",
  workingHoursPerWeek: "",
  employerName: "",
  disabilityFlag: "",
  disabilityTypeIds: [],
  disabilitySupportRequired: "",
  howDidYouHear: "",
  reasonableAdjustment: "",
  canReadWriteEnglish: "",
  llnSupportRequired: "",
  usiDeclarationAccepted: false,
  declarationAccepted: false,
  studentSignature: "",
  activeSection: "usi",
};

const stateNameById = {
  1: "VIC",
  2: "VIC",
  3: "NSW",
  4: "QLD",
  5: "WA",
  6: "SA",
  7: "TAS",
  8: "NT",
  9: "ACT",
};

const boolToChoice = (value) => value === true ? "Yes" : value === false ? "No" : "";
const textValue = (value) => (value === null || value === undefined ? "" : String(value));
const dateInputValue = (value) => textValue(value).slice(0, 10);
const dateTimeOffsetValue = (value) => {
  const date = textValue(value).trim();
  if (!date) return null;
  return /^\d{4}-\d{2}-\d{2}$/.test(date) ? `${date}T00:00:00+00:00` : date;
};
const nullableInteger = (value) => {
  if (value === "" || value === null || value === undefined) return null;
  const number = Number(value);
  return Number.isInteger(number) ? number : null;
};
const getFirstDefined = (source, keys = []) => {
  if (!source || typeof source !== "object") return "";

  const normalizedSource = Object.keys(source).reduce((acc, key) => {
    acc[String(key).toLowerCase()] = source[key];
    return acc;
  }, {});

  for (const key of keys) {
    const normalizedKey = String(key).toLowerCase();
    const value = normalizedSource[normalizedKey];
    if (value !== undefined && value !== null && value !== "") return value;
  }
  return "";
};
const getOptionId = (value, options = [], fallbackValue) => {
  const normalizedValue = textValue(value).trim();
  if (!normalizedValue || normalizedValue === "0") {
    const fallback = textValue(fallbackValue).trim();
    if (!fallback || fallback === "0") return "";
    const match = options.find((option) =>
      String(option.id) === fallback
      || String(option.name).toLowerCase() === fallback.toLowerCase()
      || String(option.code || "").toLowerCase() === fallback.toLowerCase());
    return match ? String(match.id) : "";
  }
  if (options.some((option) => String(option.id) === normalizedValue)) return normalizedValue;
  const matchValue = String(fallbackValue ?? value).toLowerCase();
  const match = options.find((option) =>
    String(option.name).toLowerCase() === matchValue
    || String(option.code || "").toLowerCase() === matchValue);
  return match ? String(match.id) : "";
};
const getOptionName = (value, options = [], fallbackValue) => {
  const normalizedValue = textValue(value).trim();
  if (normalizedValue && normalizedValue !== "0") {
    const byId = options.find((option) => String(option.id) === normalizedValue);
    if (byId) return textValue(byId.name);
    const byName = options.find((option) =>
      String(option.name).toLowerCase() === normalizedValue.toLowerCase()
      || String(option.code || "").toLowerCase() === normalizedValue.toLowerCase());
    if (byName) return textValue(byName.name);
  }
  const fallback = textValue(fallbackValue).trim();
  return fallback && fallback !== "0" ? fallback : "";
};
const parseStreetAddress = (addressLine1 = "") => {
  const normalized = textValue(addressLine1).trim();
  const match = normalized.match(/^(\d+)\s*(.*)$/);
  if (!match) return { streetNumber: "", streetName: normalized };
  return { streetNumber: match[1], streetName: match[2].trim() };
};

const requiredEnrollmentFields = [
  "usiNumber", "firstName", "lastName", "titleId", "dateOfBirth", "genderId", "mobileNumber", "email",
  "preferredContactTypeId", "emergencyContactName", "emergencyPhone", "streetNumber",
  "streetName", "suburb", "postCode", "stateId", "countryId",
  "sameAsResidential", "australianCitizen", "indigenousStatusId", "speakOtherLanguage",
  "englishProficiencyId", "completedYear12", "highestSchoolLevelId", "schoolCompletedYear",
  "ableToCompleteQualification", "hasConcessionCard",
  "disabilityFlag", "howDidYouHear", "reasonableAdjustment", "canReadWriteEnglish",
  "usiDeclarationAccepted", "declarationAccepted", "studentSignature",
];

const hasCompletedValue = (value) => {
  if (typeof value === "string") return value.trim().length > 0;
  if (typeof value === "number") return value > 0;
  return value !== null && value !== undefined && value !== false;
};

export function getEnrollmentProgress(form, documents = []) {
  let fields = form?.sameAsResidential === false
    ? [...requiredEnrollmentFields, "postalStreetNumber", "postalStreetName", "postalSuburb", "postalStateId", "postalPostCode", "postalCountryId"]
    : requiredEnrollmentFields;

  if (form?.speakOtherLanguage === "Yes") {
    fields = [...fields, "otherLanguage"];
  }

  const done = fields.filter((field) => {
    if (field === "sameAsResidential") {
      return typeof form?.sameAsResidential === "boolean";
    }

    return hasCompletedValue(form?.[field]);
  }).length;
  const requiredDocumentTypes = [
    STUDENT_DOCUMENT_TYPES.PASSPORT_STYLE_PHOTO,
    STUDENT_DOCUMENT_TYPES.DRIVER_LICENCE,
    STUDENT_DOCUMENT_TYPES.USI_SUPPORTING_DOCUMENT,
  ];
  const completedDocuments = requiredDocumentTypes.filter((typeId) =>
    documents.some((document) => Number(document?.studentDocTypeId) === typeId
      && Boolean(document?.file || document?.fileName))
  ).length;
  const total = fields.length + requiredDocumentTypes.length;

  return {
    done: done + completedDocuments,
    total,
    percentage: total === 0 ? 0 : Math.round(((done + completedDocuments) / total) * 100),
  };
}

export function getEnrollmentValidationErrors(form) {
  const errors = [];
  const requireValue = (field, label) => {
    const isComplete = field === "sameAsResidential"
      ? typeof form?.sameAsResidential === "boolean"
      : hasCompletedValue(form?.[field]);
    if (!isComplete) errors.push(`${label} is required.`);
  };

  [
    ["usiNumber", "USI number"], ["firstName", "First name"], ["lastName", "Last name"],
    ["titleId", "Title"], ["dateOfBirth", "Date of birth"], ["genderId", "Gender"],
    ["mobileNumber", "Mobile number"], ["email", "Email"], ["preferredContactTypeId", "Preferred contact type"],
    ["emergencyContactName", "Emergency contact name"], ["emergencyPhone", "Emergency contact phone"],
    ["streetNumber", "Street number"], ["streetName", "Street name"], ["suburb", "Suburb/locality"],
    ["stateId", "State/territory"], ["countryId", "Country"], ["postCode", "Postcode"],
    ["sameAsResidential", "Postal address selection"],
    ["countryOfBirthId", "Country of birth"], ["australianCitizen", "Australian citizenship"], ["indigenousStatusId", "Indigenous status"],
    ["speakOtherLanguage", "Other-language selection"], ["englishProficiencyId", "English proficiency"],
    ["completedYear12", "Year 12 completion"], ["highestSchoolLevelId", "Highest school level"],
    ["schoolCompletedYear", "School completion year"], ["ableToCompleteQualification", "Qualification completion selection"],
    ["hasConcessionCard", "Concession-card selection"], ["disabilityFlag", "Disability selection"],
    ["howDidYouHear", "Course referral source"], ["reasonableAdjustment", "Reasonable adjustment selection"],
    ["canReadWriteEnglish", "English literacy selection"], ["studentSignature", "Student signature"],
  ].forEach(([field, label]) => requireValue(field, label));

  if (form?.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) errors.push("Enter a valid email address.");
  if (form?.postCode && !/^\d{4}$/.test(form.postCode)) errors.push("Residential postcode must contain four digits.");
  if (form?.sameAsResidential === false) {
    [["postalStreetNumber", "Postal street number"], ["postalStreetName", "Postal street name"],
      ["postalSuburb", "Postal suburb/locality"], ["postalStateId", "Postal state/territory"],
      ["postalCountryId", "Postal country"], ["postalPostCode", "Postal postcode"]]
      .forEach(([field, label]) => requireValue(field, label));
    if (form.postalPostCode && !/^\d{4}$/.test(form.postalPostCode)) errors.push("Postal postcode must contain four digits.");
  }
  if (form?.speakOtherLanguage === "Yes") requireValue("otherLanguage", "Other language");
  if (form?.disabilityFlag === "Yes" && !(form.disabilityTypeIds || []).length) errors.push("Select at least one disability type.");
  if (!form?.usiDeclarationAccepted) errors.push("Confirm the USI declaration.");
  if (!form?.declarationAccepted) errors.push("Accept the enrolment declaration.");
  return errors;
}

const enrollmentSectionSteps = {
  usi: 1,
  personal: 2,
  language: 3,
  schooling: 4,
  education: 5,
  employment: 6,
  disability: 7,
  study: 8,
  lln: 9,
  declaration: 10,
};

export function mapStudentProfileToFormState(profile, master = {}) {
  if (!profile) return {};

  const streetAddress = parseStreetAddress(profile.addressLine1);
  const genderOptions = master?.genders || [];
  const cityOptions = master?.cities || [];
  const relationshipOptions = master?.emergencyRelationships || [];

  return {
    usiNumber: textValue(profile.usiNumber),
    firstName: textValue(profile.firstName),
    lastName: textValue(profile.lastName),
    dateOfBirth: dateInputValue(profile.dateOfBirth),
    gender: getOptionName(profile.genderId, genderOptions),
    genderId: getOptionId(profile.genderId, genderOptions),
    mobileNumber: textValue(profile.mobileNumber),
    email: textValue(profile.email),
    flatUnitDetails: textValue(profile.addressLine2),
    streetNumber: streetAddress.streetNumber,
    streetName: streetAddress.streetName,
    suburb: textValue(profile.suburb),
    postCode: textValue(profile.postCode),
    stateId: profile.stateId ? String(profile.stateId) : "",
    cityId: getOptionId("", cityOptions, profile.city) || null,
    countryId: profile.countryId || null,
    emergencyContactName: textValue(profile.emergencyContactName),
    emergencyRelationship: getOptionName(profile.emergencyContactRelationshipId, relationshipOptions),
    emergencyContactRelationshipId: profile.emergencyContactRelationshipId || null,
    emergencyPhone: textValue(profile.emergencyContactNumber),
  };
}

export function mapEnrollmentPayloadToFormState(payload) {
  const studentEnrollment = payload?.studentEnrollment || payload?.enrollment || {};
  const master = payload?.masterData || {};
  const addressLine1Value = getFirstDefined(studentEnrollment, ["addressLine1", "streetAddress", "streetAddressLine1", "streetAddress1"]);
  const streetNoValue = getFirstDefined(studentEnrollment, ["streetNo", "streetNumber", "streetNumber", "streetNumberNo"]);
  const streetNameValue = getFirstDefined(studentEnrollment, ["streetName", "streetName", "streetAddressName", "street"]);
  const combinedAddress = [streetNoValue, streetNameValue].filter(Boolean).join(" ") || addressLine1Value;
  const streetAddress = parseStreetAddress(combinedAddress);
  const postalStreetAddress = parseStreetAddress(studentEnrollment.postalAddressLine1);
  const currentStep = textValue(getFirstDefined(studentEnrollment, ["currentStep", "currentStepNo", "step"])).toLowerCase();
  const activeSection = {
    "1": "usi",
    "2": "personal",
    "3": "language",
    "4": "schooling",
    "5": "education",
    "6": "employment",
    "7": "disability",
    "8": "study",
    "9": "lln",
    "10": "declaration",
    usi: "usi",
    personal: "personal",
    language: "language",
    schooling: "schooling",
    education: "education",
    employment: "employment",
    disability: "disability",
    study: "study",
    lln: "lln",
    declaration: "declaration",
  }[currentStep] || "usi";

  return {
    ...initial,
    studentEnrollmentId: studentEnrollment.studentEnrollmentId ? String(studentEnrollment.studentEnrollmentId) : "",
    enrolmentNumber: textValue(studentEnrollment.enrolmentNumber),
    studentBookingId: studentEnrollment.studentBookingId ? String(studentEnrollment.studentBookingId) : "",
    usiNumber: textValue(getFirstDefined(studentEnrollment, ["usiNumber", "usiNumber", "usiNumberValue"])),
    firstName: textValue(getFirstDefined(studentEnrollment, ["firstName", "firstName"])),
    middleName: textValue(getFirstDefined(studentEnrollment, ["middleName", "middleName"])),
    lastName: textValue(getFirstDefined(studentEnrollment, ["lastName", "lastName", "last"])),
    title: getOptionName(studentEnrollment.titleId, master?.titles || [], studentEnrollment.title),
    titleId: getOptionId(studentEnrollment.titleId, master?.titles || [], studentEnrollment.title),
    dateOfBirth: dateInputValue(getFirstDefined(studentEnrollment, ["dateOfBirth", "dateOfBirth"])),
    gender: getOptionName(getFirstDefined(studentEnrollment, ["genderId", "genderNo", "sexId"]), master?.genders || [], getFirstDefined(studentEnrollment, ["gender", "sex", "genderName"])),
    genderId: getOptionId(getFirstDefined(studentEnrollment, ["genderId", "genderNo", "sexId"]), master?.genders || [], getFirstDefined(studentEnrollment, ["gender", "sex", "genderName"])),
    homePhone: textValue(getFirstDefined(studentEnrollment, ["homePhone", "homePhone"])),
    workPhone: textValue(getFirstDefined(studentEnrollment, ["workPhone", "workPhone"])),
    mobileNumber: textValue(getFirstDefined(studentEnrollment, ["mobileNumber", "mobileNumber", "mobilePhone"])),
    email: textValue(getFirstDefined(studentEnrollment, ["email", "emailAddress"])),
    preferredContactTypeId: textValue(studentEnrollment.preferredContactTypeId),
    buildingPropertyName: textValue(studentEnrollment.buildingPropertyName),
    flatUnitDetails: textValue(studentEnrollment.flatUnitDetails || studentEnrollment.addressLine2),
    streetNumber: textValue(studentEnrollment.streetNumber || streetAddress.streetNumber),
    streetName: textValue(studentEnrollment.streetName || streetAddress.streetName),
    suburb: textValue(studentEnrollment.suburb),
    postCode: textValue(getFirstDefined(studentEnrollment, ["postCode", "postCode"])),
    state: getOptionName(studentEnrollment.stateId, master?.states || [], studentEnrollment.state) || stateNameById[Number(studentEnrollment.stateId)] || "",
    stateId: getOptionId(studentEnrollment.stateId, master?.states || [], studentEnrollment.state),
    cityId: studentEnrollment.cityId || null,
    countryId: studentEnrollment.countryId || null,
    sameAsResidential: studentEnrollment.sameAsResidential !== false,
    postalBuildingPropertyName: textValue(studentEnrollment.postalBuildingPropertyName),
    postalFlatUnitDetails: textValue(studentEnrollment.postalFlatUnitDetails || studentEnrollment.postalAddressLine2),
    postalStreetNumber: textValue(studentEnrollment.postalStreetNumber || postalStreetAddress.streetNumber),
    postalStreetName: textValue(studentEnrollment.postalStreetName || postalStreetAddress.streetName),
    postalAddressLine1: textValue(getFirstDefined(studentEnrollment, ["postalType", "postalAddressLine1"])),
    postalSuburb: textValue(getFirstDefined(studentEnrollment, ["postalSuburb", "postalSuburb"])),
    postalPostCode: textValue(getFirstDefined(studentEnrollment, ["postalPostCode", "postalPostCode"])),
    postalState: getOptionName(getFirstDefined(studentEnrollment, ["postalStateId", "postalStateId"]), master?.postalStates || [], getFirstDefined(studentEnrollment, ["postalState", "postalState", "postalStateName"])) || stateNameById[Number(getFirstDefined(studentEnrollment, ["postalStateId", "postalStateId"]))] || "",
    postalStateId: getOptionId(getFirstDefined(studentEnrollment, ["postalStateId", "postalStateId"]), master?.postalStates || [], getFirstDefined(studentEnrollment, ["postalState", "postalState", "postalStateName"])),
    postalCityId: studentEnrollment.postalCityId || null,
    postalCountryId: studentEnrollment.postalCountryId || null,
    emergencyContactName: textValue(getFirstDefined(studentEnrollment, ["emergencyContactName", "emergencyContactName"])),
    emergencyRelationship: getOptionName(
      getFirstDefined(studentEnrollment, ["emergencyContactRelationshipId", "emergencyRelationshipId", "emergencyRelationshipNo"]),
      master?.emergencyRelationships || [],
      getFirstDefined(studentEnrollment, ["emergencyRelationship", "emergencyRelationship"])),
    emergencyContactRelationshipId: getOptionId(
      getFirstDefined(studentEnrollment, ["emergencyContactRelationshipId", "emergencyRelationshipId", "emergencyRelationshipNo"]),
      master?.emergencyRelationships || [],
      getFirstDefined(studentEnrollment, ["emergencyRelationship", "emergencyRelationship"])) || null,
    emergencyPhone: textValue(getFirstDefined(studentEnrollment, ["emergencyPhone", "emergencyPhone"])),
    countryOfBirth: getOptionName(getFirstDefined(studentEnrollment, ["countryOfBirthId", "countryOfBirthId", "mainLanguageId"]), master?.countriesOfBirth || master?.countries || [], getFirstDefined(studentEnrollment, ["countryOfBirth", "countryOfBirthName", "countryOfBirth", "countryName"])),
    countryOfBirthId: getOptionId(getFirstDefined(studentEnrollment, ["countryOfBirthId", "countryOfBirthId", "mainLanguageId"]), master?.countriesOfBirth || master?.countries || [], getFirstDefined(studentEnrollment, ["countryOfBirth", "countryOfBirthName", "countryOfBirth", "countryName"])),
    townOfBirth: textValue(getFirstDefined(studentEnrollment, ["townOfBirth", "townOfBirth"])),
    australianCitizen: boolToChoice(getFirstDefined(studentEnrollment, ["australianCitizen", "australianCitizen"])),
    indigenousStatus: getOptionName(studentEnrollment.indigenousStatusId, master?.indigenousStatus || [], studentEnrollment.indigenousStatus),
    indigenousStatusId: getOptionId(getFirstDefined(studentEnrollment, ["indigenousStatusId", "indigenousStatusId"]), master?.indigenousStatus || [], getFirstDefined(studentEnrollment, ["indigenousStatus", "aboriginal"])),
    speakOtherLanguage: boolToChoice(getFirstDefined(studentEnrollment, ["speakOtherLanguage", "speekOtherLanguage", "speaksOtherLanguage", "speakOtherLanguage"])),
    otherLanguage: textValue(getFirstDefined(studentEnrollment, ["otherLanguage", "otherLanguage"])),
    englishProficiency: getOptionName(getFirstDefined(studentEnrollment, ["englishProficiencyId", "englishProficiencyId"]), master?.englishProficiency || [], getFirstDefined(studentEnrollment, ["englishProficiency", "englishProficiency"])),
    englishProficiencyId: getOptionId(getFirstDefined(studentEnrollment, ["englishProficiencyId", "englishProficiencyId"]), master?.englishProficiency || [], getFirstDefined(studentEnrollment, ["englishProficiency", "englishProficiency"])),
    completedYear12: boolToChoice(getFirstDefined(studentEnrollment, ["completedYear12", "completedYear12"])),
    highestSchoolLevel: getOptionName(getFirstDefined(studentEnrollment, ["highestSchoolLevelId", "highestSchoolLevelId"]), master?.highestSchoolLevels || [], getFirstDefined(studentEnrollment, ["highestSchoolLevel", "highestSchoolLevel"])),
    highestSchoolLevelId: getOptionId(getFirstDefined(studentEnrollment, ["highestSchoolLevelId", "highestSchoolLevelId"]), master?.highestSchoolLevels || [], getFirstDefined(studentEnrollment, ["highestSchoolLevel", "highestSchoolLevel"])),
    schoolCompletedYear: textValue(getFirstDefined(studentEnrollment, ["schoolCompletedYear", "schoolCompletedYear"])),
    ableToCompleteQualification: boolToChoice(getFirstDefined(studentEnrollment, ["ableToCompleteQualification", "ableToCompleteQualification"])),
    qualificationCompletedYear: textValue(getFirstDefined(studentEnrollment, ["qualificationCompletedYear", "qualificationCompletedYear"])),
    highestQualificationIds: Array.isArray(studentEnrollment.highestQualificationIds)
      ? studentEnrollment.highestQualificationIds.map(String)
      : [],
    hasConcessionCard: boolToChoice(getFirstDefined(studentEnrollment, ["hasConcessionCard", "hasConcessionCard"])),
    concessionCardNumber: textValue(getFirstDefined(studentEnrollment, ["concessionCardNumber", "concessionCardNumber"])),
    occupation: textValue(getFirstDefined(studentEnrollment, ["occupation", "occupation"])),
    employmentStatus: textValue(getFirstDefined(studentEnrollment, ["employmentStatus", "employmentStatus"])),
    employmentStartDate: dateInputValue(getFirstDefined(studentEnrollment, ["employmentStartDate", "employmentStartDate"])),
    workingHoursPerWeek: textValue(getFirstDefined(studentEnrollment, ["workingHoursPerWeek", "workingHoursPerWeek"])),
    employerName: textValue(getFirstDefined(studentEnrollment, ["employerName", "employerName"])),
    disabilityFlag: boolToChoice(studentEnrollment.disabilityFlag),
    disabilityTypeIds: Array.isArray(studentEnrollment.disabilityTypeIds)
      ? studentEnrollment.disabilityTypeIds.map(String)
      : [],
    disabilitySupportRequired: textValue(getFirstDefined(studentEnrollment, ["disabilitySupportRequired", "disabilitySupportRequired"])),
    howDidYouHear: textValue(getFirstDefined(studentEnrollment, ["howDidYouHear", "howDidYouHear"])),
    reasonableAdjustment: boolToChoice(getFirstDefined(studentEnrollment, ["reasonableAdjustment", "reasonableAdjustment"])),
    canReadWriteEnglish: boolToChoice(getFirstDefined(studentEnrollment, ["canReadWriteEnglish", "canReadWriteEnglish"])),
    llnSupportRequired: textValue(getFirstDefined(studentEnrollment, ["llnSupportRequired", "llnSupportRequired"])),
    usiDeclarationAccepted: Boolean(getFirstDefined(studentEnrollment, ["declarationAccepted"])),
    declarationAccepted: Boolean(getFirstDefined(studentEnrollment, ["declarationAccepted"])),
    studentSignature: textValue(getFirstDefined(studentEnrollment, ["studentSignature", "studentSignature"])),
    activeSection,
  };
}

export function mapFormStateToEnrollment(form, documents = []) {
  const residentialAddress = [form.streetNumber, form.streetName].filter(Boolean).join(" ");
  const postalStreetAddress = [form.postalStreetNumber, form.postalStreetName].filter(Boolean).join(" ");
  const sameAsResidential = form.sameAsResidential !== false;
  const postalStateId = nullableInteger(form.postalStateId);

  const enrollment = {
    tStamp: null,
    studentEnrollmentId: form.studentEnrollmentId ? Number(form.studentEnrollmentId) : 0,
    enrolmentNumber: form.enrolmentNumber || null,
    studentBookingId: form.studentBookingId ? Number(form.studentBookingId) : null,
    progressPercentage: getEnrollmentProgress(form, documents).percentage,
    currentStepNo: enrollmentSectionSteps[form.activeSection] || 1,
    currentStep: String(enrollmentSectionSteps[form.activeSection] || 1),
    isSubmitted: false,
    submittedDate: null,
    usiNumber: form.usiNumber || null,
    title: form.title || null,
    firstName: form.firstName || null,
    middleName: form.middleName || null,
    lastName: form.lastName || null,
    preferredName: form.firstName || null,
    genderId: nullableInteger(form.genderId),
    dateOfBirth: dateTimeOffsetValue(form.dateOfBirth),
    email: form.email || null,
    preferredContactTypeId: nullableInteger(form.preferredContactTypeId),
    mobileNumber: form.mobileNumber || null,
    homePhone: form.homePhone || null,
    workPhone: form.workPhone || null,
    buildingPropertyName: form.buildingPropertyName || null,
    flatUnitDetails: form.flatUnitDetails || null,
    streetNumber: form.streetNumber || null,
    streetName: form.streetName || null,
    addressLine1: residentialAddress || null,
    addressLine2: form.flatUnitDetails || null,
    suburb: form.suburb || null,
    postCode: form.postCode || null,
    stateId: nullableInteger(form.stateId),
    cityId: nullableInteger(form.cityId),
    countryId: nullableInteger(form.countryId),
    state: form.state || "",
    sameAsResidential,
    postalBuildingPropertyName: sameAsResidential ? (form.buildingPropertyName || null) : (form.postalBuildingPropertyName || null),
    postalFlatUnitDetails: sameAsResidential ? (form.flatUnitDetails || null) : (form.postalFlatUnitDetails || null),
    postalStreetNumber: sameAsResidential ? (form.streetNumber || null) : (form.postalStreetNumber || null),
    postalStreetName: sameAsResidential ? (form.streetName || null) : (form.postalStreetName || null),
    postalAddressLine1: sameAsResidential ? residentialAddress : postalStreetAddress,
    postalAddressLine2: sameAsResidential ? (form.flatUnitDetails || "") : (form.postalFlatUnitDetails || ""),
    postalSuburb: sameAsResidential ? (form.suburb || "") : (form.postalSuburb || ""),
    postalPostCode: sameAsResidential ? (form.postCode || "") : (form.postalPostCode || ""),
    postalStateId: postalStateId || (sameAsResidential ? nullableInteger(form.stateId) : null),
    postalCityId: sameAsResidential ? nullableInteger(form.cityId) : nullableInteger(form.postalCityId),
    postalCountryId: sameAsResidential ? nullableInteger(form.countryId) : nullableInteger(form.postalCountryId),
    postalState: sameAsResidential ? (form.state || "") : (form.postalState || ""),
    countryOfBirthId: nullableInteger(form.countryOfBirthId),
    townOfBirth: form.townOfBirth || null,
    australianCitizen: form.australianCitizen === "Yes",
    indigenousStatusId: nullableInteger(form.indigenousStatusId),
    indigenousStatus: form.indigenousStatus || null,
    speakOtherLanguage: form.speakOtherLanguage === "Yes",
    otherLanguage: form.otherLanguage || null,
    englishProficiency: form.englishProficiency || null,
    englishProficiencyId: form.englishProficiencyId ? String(form.englishProficiencyId) : "",
    completedYear12: form.completedYear12 === "Yes",
    highestSchoolLevel: form.highestSchoolLevel || null,
    highestSchoolLevelId: form.highestSchoolLevelId ? String(form.highestSchoolLevelId) : null,
    schoolCompletedYear: nullableInteger(form.schoolCompletedYear),
    ableToCompleteQualification: form.ableToCompleteQualification === "Yes",
    qualificationCompletedYear: nullableInteger(form.qualificationCompletedYear),
    highestQualificationIds: (form.highestQualificationIds || [])
      .map(nullableInteger)
      .filter((id) => id !== null),
    hasConcessionCard: form.hasConcessionCard === "Yes",
    concessionCardNumber: form.concessionCardNumber || null,
    employmentStatus: form.employmentStatus || "",
    occupation: form.occupation || null,
    employmentStartDate: dateTimeOffsetValue(form.employmentStartDate),
    workingHoursPerWeek: nullableInteger(form.workingHoursPerWeek),
    employerName: form.employerName || null,
    disabilityFlag: form.disabilityFlag === "Yes",
    disabilityTypeIds: (form.disabilityTypeIds || [])
      .map(nullableInteger)
      .filter((id) => id !== null),
    disabilitySupportRequired: form.disabilitySupportRequired || null,
    howDidYouHear: form.howDidYouHear || null,
    reasonableAdjustment: form.reasonableAdjustment === "Yes",
    canReadWriteEnglish: form.canReadWriteEnglish === "Yes",
    llnSupportRequired: form.llnSupportRequired || null,
    declarationAccepted: form.declarationAccepted === true,
    declarationDate: form.declarationAccepted ? new Date().toISOString() : null,
    studentSignature: form.studentSignature || "",
    emergencyPhone: form.emergencyPhone || "",
    emergencyContactName: form.emergencyContactName || "",
    emergencyContactRelationshipId: nullableInteger(form.emergencyContactRelationshipId),
    insertedBy: "frontend",
    updatedBy: "frontend",
    userInfo: {
      insertedBy: "frontend",
      updatedBy: "frontend",
    },
  };

  return enrollment;
}

export { initial };
import { STUDENT_DOCUMENT_TYPES } from "@/constants/studentDocuments";
